import React, { FC, ReactElement, useContext } from 'react';
import { Heading, ThemeContext } from 'grommet';
import { Link } from 'gatsby';
import { normalizeColor } from 'grommet/utils';

export const Logo: FC = (): ReactElement => {
  const theme = useContext(ThemeContext);
  return (
    <Link
      to="/"
      style={{ textDecoration: `none`, color: normalizeColor(`text`, theme) }}
    >
      <Heading level={1}>pentester</Heading>
    </Link>
  );
};
